import {
  EbpCase,
  ReferralGeneric,
  dateTimeToLocalDateTimeString,
} from '@packages/core-shared';
import { Button, FormLabel } from '@percihealth/react';
import { ReferralDownloadFileLink } from './ReferralDownloadFileLink';
import ReferralDocumentsTable from './ReferralDocumentsTable';

export const GenericReferralDetails = ({
  ebpCase,
  referral,
  readonly,
}: {
  ebpCase: EbpCase;
  referral: ReferralGeneric;
  readonly: boolean;
}) => {
  return (
    <>
      <div>
        <FormLabel bold>Referrer name</FormLabel>
        <span>
          {`${referral.referrer.firstName} ${referral.referrer.lastName}`}
        </span>
      </div>
      <div>
        <FormLabel bold>Referrer email</FormLabel>
        <span>{referral.referrer?.email ?? ''}</span>
      </div>
      {/* <div>
        <FormLabel bold>GIP code</FormLabel>
        <span>{referral.gip?.code}</span>
      </div> */}
      <div>
        <FormLabel bold>Medical history</FormLabel>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            alignItems: 'start',
          }}
        >
          <div>
            Sent to EHR:{' '}
            {ebpCase.patient.medicalHistory?.sentToHealee?.at ? (
              <div>
                {dateTimeToLocalDateTimeString(
                  ebpCase.patient.medicalHistory.sentToHealee.at,
                )}{' '}
                <br />
                by {ebpCase.patient.medicalHistory.sentToHealee.by}
              </div>
            ) : (
              'No'
            )}
          </div>
          <Button
            disabled={
              readonly || !!ebpCase.patient.medicalHistory?.sentToHealee
            }
            onClick={() => {
              window.open(
                `/cases/${ebpCase.id}/medical-history-validation`,
                '_blank',
              );
            }}
          >
            Verify
          </Button>
        </div>
      </div>
      <div>
        <FormLabel bold>Consent form</FormLabel>
        <ReferralDownloadFileLink
          referralId={referral.id}
          fileName={referral.documents?.consent?.name}
          filePath={referral.documents?.consent?.path}
        />
      </div>
      <div>
        <FormLabel bold>Referral forms</FormLabel>
        <ReferralDocumentsTable
          referralId={referral.id}
          forms={referral.documents?.referrals ?? []}
          readonly={readonly}
        />
      </div>
    </>
  );
};
